import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Family } from './useFamily';
import { CreateFamilyPayload } from './useCreateFamily';

type UpdateFamilyPayload = Partial<CreateFamilyPayload>;

export function useUpdateFamily() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation({
    mutationFn: ({ id, values }: { id: string; values: UpdateFamilyPayload }) =>
      api.put<Family>(`families/${id}`, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
    },
  });

  const updateFamily = async (id: string, values: UpdateFamilyPayload) => {
    return mutateAsync({ id, values });
  };

  return {
    updateFamily,
    error,
    isLoading,
    reset,
  };
}
